<div class="card">
  <div class="header">
    <div>
      <span>Série </span>
      <span>{{ nfce?.serie ?? "—" }}</span>
    </div>
    <div>
      <span>Nº </span>
      <span>{{ nfce?.numero ?? "—" }}</span>
    </div>
  </div>
  <div class="body">
    <div class="prop">
      <small>CONSUMIDOR: </small>
      <span *ngIf="nfce?.destinatario; else naoIdentificado">
        {{ nfce?.destinatario ?? "" | formatter: "cpfCnpj" }}
      </span>
      <ng-template #naoIdentificado>
        <span class="muted">não identificado</span>
      </ng-template>
    </div>
    <div class="prop" *ngIf="nfce?.clienteNome">
      <small>OBRA: </small>
      <span>
        {{ nfce?.numeroObra ? "#" + nfce?.numeroObra + " · " : "" }}
        {{ nfce?.clienteNome }}
      </span>
    </div>
    <div class="prop">
      <small>VALOR: </small>
      <span>{{ nfce?.valor | currency: "BRL" }}</span>
    </div>
    <div class="prop">
      <small>SITUAÇÃO: </small>
      <span [ngClass]="status.toLowerCase()">{{ nfce?.status }}</span>
    </div>
    <div class="prop" *ngIf="!rejeitada; else error">
      <small>EMISSÃO: </small>
      <span>{{ nfce?.emissao }}</span>
    </div>
    <div class="prop prazo" *ngIf="autorizada && segundosRestantes() !== null">
      <small>CANCELAMENTO: </small>
      <span [class.encerrado]="!podeCancelar">
        {{ podeCancelar ? "até " + tempoRestante() : "prazo encerrado" }}
      </span>
    </div>
    <div class="info-container">
      <i
        class="pi pi-info-circle tooltip-icon"
        role="button"
        tabindex="0"
        aria-label="Exibir detalhes da nota"
        (click)="showOverlay($event)"
        (keydown.enter)="showOverlay($event)"
      ></i>

      <p-overlayPanel
        #overlay
        appendTo="body"
        [style]="{ 'min-width': '200px' }"
      >
        <div class="copy-container">
          <p><strong>ID:</strong> {{ nfce?.id }}</p>
          <p *ngIf="nfce?.chave"><strong>Chave:</strong> {{ nfce?.chave }}</p>
          <p *ngIf="nfce?.protocolo">
            <strong>Protocolo:</strong> {{ nfce?.protocolo }}
          </p>

          <button (click)="copyToClipboard(nfce?.id)">
            <i class="pi pi-copy"></i> Copiar ID
          </button>
        </div>
      </p-overlayPanel>
    </div>
    <ng-template #error>
      <div class="prop">
        <button (click)="showError()">
          <small [style.color]="'red'">
            <i class="pi pi-exclamation-triangle"></i>
            Ver detalhes da rejeição
          </small>
        </button>
      </div>
    </ng-template>
  </div>
  <div class="footer">
    <div class="content">
      <p-menu #menu [model]="menuOptions()" [popup]="true"></p-menu>
      <app-button
        text="Opções"
        icon="pi-bars"
        (click)="menu.toggle($event)"
        backgroundColor="var(--pink-500)"
        textAlign="flex-start"
        [fullWidth]="true"
        [disabled]="!items().length"
      ></app-button>
    </div>
  </div>
</div>
